import { call, put, all, takeLatest } from "redux-saga/effects";

import { getEmployeeOfManagerAPI } from "core/http/service/timeKeeping";
import {
  getEmployeeOfManagerFailed,
  getEmployeeOfManagerStart,
  getEmployeeOfManagerSuccess,
} from "../redux/getEmployeeOfManager";
import { toast } from "react-toastify";

function* getEmployeeOfManagerWork(action) {
  const data = action.payload;

  try {
    const res = yield call(getEmployeeOfManagerAPI, data);
    if (res) {
      const listData = res?.map((it) => ({
        label: it?.name,
        value: it?.employeeCode,
      }));
      yield put({
        type: getEmployeeOfManagerSuccess.type,
        payload: listData,
      });
      //   toast.success("Cập nhật đơn thành công!");
    }
  } catch (err: any) {
    yield put({
      type: getEmployeeOfManagerFailed.type,
    });
    toast.error(err?.response?.data?.message || "Đã có lỗi xảy ra!");
  }
}

function* watchGetEmployeeOfManager() {
  yield takeLatest(getEmployeeOfManagerStart.type, getEmployeeOfManagerWork);
}

export default function* getEmployeeOfManagerSaga() {
  yield all([watchGetEmployeeOfManager()]);
}
